import React from 'react';
import './NotificationDisplay.css';

interface SuccessDisplayProps {
  message: string;
  className?: string;
  onClose?: () => void;
}

const SuccessDisplay: React.FC<SuccessDisplayProps> = ({ message, className = '', onClose }) => {
  if (!message) return null;

  return (
    <div className={`success-display ${className}`}>
      <div className="success-container">
        <div className="success-header">
          <div className="success-header-left">
            <i className="fas fa-check-circle success-icon"></i>
            <span className="success-title">Success!</span>
          </div>
          {onClose && (
            <button 
              type="button" 
              className="success-close-btn"
              onClick={onClose}
              aria-label="Close success message"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
        <div className="success-message">
          {message}
        </div>
      </div>
    </div>
  );
};

export default SuccessDisplay; 